export default {
  namespaced: true,
  state: {
    account: null,
    clinics: [],
    accountClinic: null,
    currencies: null,
    doctors: [],
    clinicAdmins: [],
  },
  getters: {
    accessToken: () => localStorage.getItem('token'),
    refreshToken: () => localStorage.getItem('refreshToken'),
    sessionId: () => localStorage.getItem('sessionId'),
  },
  mutations: {
    setClinics: (state, payload) => state.clinics = payload,
    setAccount: (state, payload) => state.account = payload,
    setDoctors: (state, payload) => state.doctors = payload,
    setClinicAdmins: (state, payload) => state.clinicAdmins = payload,
    setAccountClinic: (state, payload) => state.accountClinic = payload,
    setClinicCurrencies: (state, payload) => state.currencies = payload,
  },
  actions: {
    clearSession: ({ commit }) => {
      commit('setAccount', null);
      commit('setAccountClinic', null);
    },
  },
};
